import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { ArrowUp, ArrowDown, LayoutTemplate } from 'lucide-react';
import { getHome } from './homeApi';
import HomeActions from './HomeActions';

const NOMES = {
  destaques: 'Produtos em Destaque',
  ofertas: 'Ofertas e Promoções',
  categorias: 'Abas de categorias',
  produtos: 'Grade de produtos',
};

export default function Personalizar() {
  const { data: homeData, isLoading } = useQuery({ queryKey: ['admin-home'], queryFn: getHome });
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    if (homeData) setCfg(JSON.parse(JSON.stringify(homeData.rascunho)));
  }, [homeData]);

  if (isLoading || !cfg) return <p className="text-sm text-slate-400">Carregando...</p>;

  const setSecao = (id, parcial) =>
    setCfg({ ...cfg, secoes: cfg.secoes.map((s) => (s.id === id ? { ...s, ...parcial } : s)) });

  const mover = (i, dir) => {
    const j = i + dir;
    if (j < 0 || j >= cfg.secoes.length) return;
    const secoes = [...cfg.secoes];
    [secoes[i], secoes[j]] = [secoes[j], secoes[i]];
    setCfg({ ...cfg, secoes });
  };

  const inputCls = 'mt-1 w-full rounded-xl border border-slate-300 bg-white px-3.5 py-2 text-sm outline-none focus:border-mk-blue';
  const labelCls = 'text-[11px] font-bold uppercase text-slate-400';

  return (
    <div data-testid="admin-personalizar" className="max-w-2xl">
      <h1 className="flex items-center gap-2 font-heading text-2xl font-extrabold text-slate-900">
        <LayoutTemplate size={23} className="text-mk-blue" /> Personalizar página inicial
      </h1>
      <p className="mt-1 text-sm text-slate-500">Controle as seções do catálogo sem editar código. Salve o rascunho e publique quando estiver pronto.</p>

      <div className="mt-5 rounded-2xl bg-white p-5 shadow-sm">
        <h2 className="font-heading text-base font-extrabold text-slate-900">Carrossel de banners</h2>
        <label className="mt-3 flex items-center gap-3">
          <input data-testid="home-carrossel-ativo" type="checkbox" checked={cfg.carrossel.ativo} onChange={(e) => setCfg({ ...cfg, carrossel: { ...cfg.carrossel, ativo: e.target.checked } })} className="h-5 w-5 accent-mk-blue" />
          <span className="text-sm font-bold text-slate-800">Exibir carrossel no lugar do banner padrão</span>
        </label>
        <p className="mt-1 text-xs text-slate-400">Sem banners ativos, o banner padrão da loja é exibido automaticamente.</p>
        <div className="mt-3 max-w-[220px]">
          <label className={labelCls}>Intervalo entre banners (segundos)</label>
          <input data-testid="home-intervalo" type="number" min="3" max="30" value={cfg.carrossel.intervaloSeg} onChange={(e) => setCfg({ ...cfg, carrossel: { ...cfg.carrossel, intervaloSeg: parseInt(e.target.value, 10) || 6 } })} className={inputCls} />
        </div>
      </div>

      <div className="mt-4 rounded-2xl bg-white p-5 shadow-sm">
        <h2 className="font-heading text-base font-extrabold text-slate-900">Seções da página</h2>
        <p className="mt-1 text-xs text-slate-400">Ative, desative, renomeie e mude a ordem das seções.</p>
        <div className="mt-3 space-y-3">
          {cfg.secoes.map((s, i) => (
            <div key={s.id} data-testid={`home-secao-${s.id}`} className="rounded-2xl border border-slate-100 bg-slate-50 p-4">
              <div className="flex items-center gap-3">
                <input data-testid={`home-secao-ativo-${s.id}`} type="checkbox" checked={s.ativo} onChange={(e) => setSecao(s.id, { ativo: e.target.checked })} className="h-5 w-5 accent-mk-blue" />
                <span className="flex-1 text-sm font-bold text-slate-800">{NOMES[s.id] || s.id}</span>
                <button data-testid={`home-secao-up-${s.id}`} onClick={() => mover(i, -1)} disabled={i === 0} aria-label="Subir" className="rounded-lg p-1.5 text-slate-500 hover:bg-slate-200 disabled:opacity-30"><ArrowUp size={15} /></button>
                <button data-testid={`home-secao-down-${s.id}`} onClick={() => mover(i, 1)} disabled={i === cfg.secoes.length - 1} aria-label="Descer" className="rounded-lg p-1.5 text-slate-500 hover:bg-slate-200 disabled:opacity-30"><ArrowDown size={15} /></button>
              </div>
              {s.id !== 'categorias' && (
                <div className="mt-3 grid gap-3 sm:grid-cols-2">
                  <div>
                    <label className={labelCls}>Título</label>
                    <input data-testid={`home-secao-titulo-${s.id}`} value={s.titulo} onChange={(e) => setSecao(s.id, { titulo: e.target.value })} className={inputCls} />
                  </div>
                  <div>
                    <label className={labelCls}>Subtítulo</label>
                    <input value={s.subtitulo} onChange={(e) => setSecao(s.id, { subtitulo: e.target.value })} className={inputCls} />
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <HomeActions cfg={cfg} temAlteracoes={homeData?.temAlteracoes} />
    </div>
  );
}
